import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { UI_COLORS } from "../styles/clientePortalStyles";

// ==================== ESTILOS ====================

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 12,
    overflow: "hidden",
  },
  headerCell: {
    backgroundColor: UI_COLORS.background.filters,
    fontWeight: 600,
    color: UI_COLORS.text.primary,
  },
  row: {
    "&:hover": {
      backgroundColor: UI_COLORS.background.filters,
    },
  },
}));

/**
 * Componente TableSkeleton - Loading state para tablas
 *
 * @param {number} rows - Cantidad de filas a mostrar (default: 5)
 * @param {number} columns - Cantidad de columnas a mostrar (default: 5)
 * @param {Array<string>} headers - Nombres de las columnas (opcional)
 * @param {boolean} showActions - Si mostrar columna de acciones (default: false)
 *
 * @example
 * {isLoading && <TableSkeleton rows={5} columns={6} />}
 *
 * @example con headers
 * {isLoading && (
 *   <TableSkeleton
 *     rows={5}
 *     headers={["Tarea", "Tipo", "Estado", "Fecha", "Progreso"]}
 *     showActions
 *   />
 * )}
 */
export default function TableSkeleton({
  rows = 5,
  columns = 5,
  headers = [],
  showActions = false,
}) {
  const classes = useStyles();

  // Si se proporcionan headers, usar esa cantidad de columnas
  const totalColumns = headers.length > 0 ? headers.length : columns;
  const actualColumns = showActions ? totalColumns + 1 : totalColumns;

  return (
    <TableContainer className={classes.container}>
      <Table>
        {/* Header con skeletons o nombres reales */}
        <TableHead>
          <TableRow>
            {headers.length > 0 ? (
              <>
                {headers.map((header, index) => (
                  <TableCell key={index} className={classes.headerCell}>
                    {header}
                  </TableCell>
                ))}
                {showActions && (
                  <TableCell className={classes.headerCell} align="right">
                    Acciones
                  </TableCell>
                )}
              </>
            ) : (
              <>
                {[...Array(actualColumns)].map((_, index) => (
                  <TableCell key={index} className={classes.headerCell}>
                    <Skeleton variant="text" width="80%" />
                  </TableCell>
                ))}
              </>
            )}
          </TableRow>
        </TableHead>

        {/* Body con skeletons */}
        <TableBody>
          {[...Array(rows)].map((_, rowIndex) => (
            <TableRow key={rowIndex} className={classes.row}>
              {[...Array(actualColumns)].map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton
                    variant="text"
                    width={
                      colIndex === actualColumns - 1 && showActions ? 60 : "90%"
                    }
                    animation="wave"
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
